.data-manager-frozen-toolbar {
  /* Match the dark feature banner on the home page. */
  background: #191613;
}

.data-manager-frozen-grid tbody tr {
  --data-manager-frozen-background: var(--color-white, #fff);
}

.data-manager-frozen-grid tbody tr:nth-child(odd),
.data-manager-frozen-grid tbody tr[data-frozen-row-state="create"] {
  --data-manager-frozen-background: var(--color-slate-100, #f1f5f9);
}

.data-manager-frozen-grid tbody tr[data-frozen-row-state="draft"] {
  --data-manager-frozen-background: color-mix(in srgb, var(--color-amber-50, #fffbeb) 55%, white);
}

.data-manager-frozen-grid tbody tr[data-frozen-row-state="highlight"],
.data-manager-frozen-grid tbody tr[data-frozen-row-state="normal"]:hover {
  --data-manager-frozen-background: var(--color-legacy-teal-soft);
}

.data-manager-frozen-grid tbody td[data-frozen-cell="true"],
.data-manager-frozen-grid tbody td:first-child[style*="sticky"] {
  background-color: var(--data-manager-frozen-background);
}

.data-manager-frozen-grid thead th:first-child[style*="sticky"] {
  background-color: var(--color-slate-100, #f1f5f9);
}
